import routeNames from '@enums/route-names';
import tabNames from '@enums/tab-names';
import { maxBy, find } from 'lodash';
import store from '@/js/store';

export default {
    toAllCampaignsView({ tabName = tabNames.planning, router }) {
        router.push({ name: routeNames[`${tabName}AllCampaignsView`] });
    },
    toCampaignView({ tabName = tabNames.planning, campaignId, router }) {
        router.push({ name: routeNames[`${tabName}SingleCampaignView`], params: { campaignId } });
    },
    toSubCampaignView({ tabName = tabNames.planning, subCampaignId, router }) {
        router.push({
            name: routeNames[`${tabName}SingleSubCampaignView`],
            params: { subCampaignId },
        });
    },
    async toFavouriteScenario({ subCampaign, router }) {
        let favScenario;
        const subCampaignId = subCampaign._id;
        await store.dispatch('scenarios/fetchScenariosForSubCampaign', subCampaign, {
            root: true,
        });
        const scenarios = store.getters['scenarios/getScenariosBySubCampaignId'](subCampaignId);
        if (store.state.clientConfig.generalConfig.oneScenarioForAllCategories) {
            favScenario = find(scenarios, 'isFavourite');
        } else {
            const favScenarios = scenarios.filter(i => i.isFavourite);
            favScenario = maxBy(favScenarios, scenario => scenario.categories.length);
        }

        const scenarioId = favScenario._id;
        router.push({ name: routeNames.scenarioView, params: { subCampaignId, scenarioId } });
    },
    toScenarioView({ scenarioId, router }) {
        router.push({ name: routeNames.scenarioView, params: { scenarioId } });
    },
    toPromotionsViewerView({ router }) {
        router.push({ name: routeNames.promotionsViewer });
    },
    toSupplierCommitmentsView({ category, supplier, router } = {}) {
        router.push({ name: routeNames.supplierCommitmentsView, query: { category, supplier } });
    },
    toSupplierCommitmentView({ supplierCommitmentId, router }) {
        router.push({ name: routeNames.supplierCommitmentView, params: { supplierCommitmentId } });
    },
    toVariableFundingView({ router }) {
        router.push({ name: routeNames.variableFundingView });
    },
    toRateCardView({ router }) {
        router.push({ name: routeNames.rateCardView });
    },
    toPromotionView({ promotionId, router }) {
        router.push({ name: routeNames.promotionView, params: { promotionId } });
    },
    toPromotionTabView({ tabName, promotionId, router }) {
        router.push({ name: routeNames.promotionTabView, params: { tabName, promotionId } });
    },
    // Admin area
    toFreeGiftsView({ router }) {
        router.push({ name: routeNames.freeGiftsView });
    },
    // admin loyalty points
    toLoyaltyPointsView({ router }) {
        router.push({ name: routeNames.loyaltyPointsView });
    },
    // admin loyalty points
    toConfigEditorView({ router }) {
        router.push({ name: routeNames.configEditorView });
    },
    // Parking Lot area
    toParkingLotView({ router }) {
        router.push({ name: routeNames.parkingLotView });
    },
    toPastPromotionsView({ router }) {
        router.push({ name: routeNames.pastPromotionsView });
    },
    toSubCampaignAllocationView({ router }) {
        router.push({ name: routeNames.subCampaignAllocationView });
    },

    // Products area
    toProxyProductsView({ router }) {
        router.push({ name: routeNames.proxyProductsView });
    },
    toProductGroupsView({ router }) {
        router.push({ name: routeNames.productGroupsView });
    },

    // reporting
    toReporting({ router }) {
        router.push({ name: routeNames.reporting });
    },
    toBookmark({ bookmarkId, router }) {
        router.push({ name: routeNames.bookmark, params: { bookmarkId } });
    },
    // user permissions
    toUserPermissions({ router }) {
        router.push({ name: routeNames.userPermissions });
    },
    toAdminPage({ router }) {
        router.push({ name: routeNames.admin });
    },
    toClientSystemsTesting({ router }) {
        router.push({ name: routeNames.clientSystemsTesting });
    },
    toRedisBull({ router }) {
        router.push({ name: routeNames.redisBull });
    },
    toFeatureToggler({ router }) {
        router.push({ name: routeNames.featureToggler });
    },
};
